import { assoc, compose, isNil, map, omit, pick, reject } from 'ramda'

import { hasValue } from '../../../../utils/helpers/value'
import replaceAllReferences from '../../../../utils/helpers/replaceAllReferences'

const formatJson = v => {
  if (!hasValue(v) || v === null || v === undefined) return null
  return JSON.stringify(v)
}

const cleanDocuments = map(pick(['id', 'description']))
const cleanDocumentsToTemplate = map(pick([`src`, `type`, 'description']))

export const cleanRequest = item => {
  const questions = item?.questions

  const references = questions.reduce((acc = [], question) => {
    return acc.concat(question.reference).concat(question.options.map(item => item.reference))
  }, [])
  const isFromOrToTemplates = item.fromTemplates || item.toTemplates

  return compose(
    omit([
      '__typename',
      'id',
      'fromTemplates',
      'toTemplates',
      'templatesProject',
      'templatesProject__error',
      'name__error'
    ]),
    item =>
      assoc(
        'questions',
        map(
          compose(
            omit(['__typename', 'type', 'id', 'category']),
            question => assoc('nonComplianceConditions', formatJson(question.nonComplianceConditions), question),
            question => assoc('displayConditions', formatJson(question.displayConditions), question),
            question => assoc('data', JSON.stringify(question.data || {}), question),
            question => assoc('options', map(omit(['__typename', 'id']), question.options), question),
            question => (isFromOrToTemplates ? question : assoc('typeId', question.type.id, question)),
            question => (isFromOrToTemplates ? question : assoc('categoryId', question.category?.id, question)),
            question => (isFromOrToTemplates ? assoc('categoryName', question.category?.name, question) : question),
            question =>
              isFromOrToTemplates
                ? assoc('documents', cleanDocumentsToTemplate(reject(isNil, question.documents || [])), question)
                : assoc('documents', cleanDocuments(reject(isNil, question.documents || [])), question)
          ),
          item.questions
        ),
        item
      ),
    assoc('questions', replaceAllReferences(questions, references)),
    item => (isFromOrToTemplates ? omit(['typeId'], item) : item)
  )(item)
}
